import { useEffect, useState } from 'react';
import { apiClient } from '../../../../utilities/apiClient';

// Cursor cache keyed by page index. Consumer sends monotonically-increasing
// page numbers and we resolve to the matching cursor — same pattern as
// AnonymousUsers / PhoneVerifications. clearCursorCache is called from the
// page's unmount cleanup so switching tabs doesn't replay stale cursors.
const cursorByPage = new Map();
export const clearCursorCache = () => cursorByPage.clear();

export const fetchAllUsers = async ({ page, docLimit }) => {
  const cursor = page === 0 ? null : cursorByPage.get(page - 1) ?? null;
  const res = await apiClient.get('/admin/users', {
    params: { limit: docLimit, ...(cursor ? { cursor } : {}) },
  });
  const items = res.data.items ?? [];
  if (res.data.nextCursor) cursorByPage.set(page, res.data.nextCursor);
  return items;
};

export const onUpdateUser = ({ userId, data }) =>
  apiClient.patch(`/admin/users/${userId}`, data);

export const getCountOfUserTables = async () => {
  const res = await apiClient.get('/admin/users/count');
  return res.data.count ?? 0;
};

export const getCountOfPostTables = async () => {
  const res = await apiClient.get('/admin/posts/count');
  return res.data.count ?? 0;
};

export const useGetCountOfTable = (type = 'users') => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    (async () => {
      const value = type === 'users' ? await getCountOfUserTables() : await getCountOfPostTables();
      setCount(value);
    })();
  }, [type]);
  return { count };
};
